var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedStepIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06024 12.2319C5.74008 12.2319 5.43593 12.1038 5.21181 11.8797L0.681548 7.34946C0.217316 6.88523 0.217316 6.11685 0.681548 5.65262C1.14578 5.18838 1.91416 5.18838 2.3784 5.65262L6.06024 9.33445L14.2884 1.10635C14.7526 0.642121 15.521 0.642121 15.9852 1.10635C16.4494 1.57058 16.4494 2.33896 15.9852 2.8032L6.90866 11.8797C6.68455 12.1038 6.3804 12.2319 6.06024 12.2319Z",
    fill: "#F3F6F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedStepIcon);
export default __webpack_public_path__ + "static/media/CompletedStepIcon.f8b29d4cd73375984beee0547c61dd0d.svg";
export { ForwardRef as ReactComponent };